import { useQuery } from "@tanstack/react-query";
import isEmpty from "lodash.isempty";
import cmsClient from "src/services/cmsClient";
import { adaptAppBrand } from "../../adapters/adaptAppBrands";

const fetchActiveAppBrand = async () => {
	const url = "/homepage/admin/app-branding/";

	const response = await cmsClient.get<IAppBrand[]>(url, {
		params: {
			published: true
		}
	});

	return response.data;
};

const useActiveAppBrand = () => {
	const query = useQuery(["active-app-brand"], fetchActiveAppBrand, {
		select(data) {
			if (isEmpty(data)) return {};

			return adaptAppBrand(data[0]);
		}
	});

	return query;
};

export default useActiveAppBrand;
